module.exports = __webpack_public_path__ + "img/undraw_contact_us_15o2.bf49b253.svg";